/** Browser stub for Node `fs` used by @o3co/ts.hocon file includes (unused for string parsing). */
export const readFileSync = () => {
  throw new Error('fs.readFileSync is not available in the browser.');
};

export const promises = {
  readFile: async () => {
    throw new Error('fs.promises.readFile is not available in the browser.');
  },
};
